// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__WV48Q","footer":"ChangeClinic_footer__cWlS2"};